import { useState, useEffect } from 'react'
import IntercomWidget, { INTERCOM_APP_ID } from './IntercomWidget'
import { OrganisationRoleEnum } from 'types/Organisation'

import { useLocation } from 'react-router-dom'
import { useIntercomQuery } from './useIntercom.codegen'
import { apolloClientPublic } from 'front-end/src/graphql/apolloClient'
import { useLooopTheme } from '../useLooopTheme'
import isMobile from 'ismobilejs'

export const useIntercom = (hide) => {
  const { phone } = isMobile()
  const { theme } = useLooopTheme()
  const [loaded, setLoaded] = useState(false)
  const { data } = useIntercomQuery({
    client: apolloClientPublic,
    fetchPolicy: 'cache-first',
    skip: phone
  })

  const loc = useLocation()
  const isOnTopicPage = !loc.pathname.match(/topic/) // we don't display on topic page to allow all the screen space for the topic

  useEffect(() => {
    const user = data?.session?.user

    if (hide || phone || !user) {
      return
    }

    const userData = {
      organisation: data?.organisation?.name,
      email: user.email as string,
      accountName: user.account_name,
      id: user.email
    }

    const isAdmin = user.organisation_role === OrganisationRoleEnum.ADMIN // TODO: useAcl() + ACL.isAdmin()
    const enable = isAdmin && isOnTopicPage

    if (!window.Intercom && enable) {
      IntercomWidget()
    }

    if (window.Intercom) {
      if (loaded) {
        window.Intercom('update', {
          app_id: INTERCOM_APP_ID,
          ...userData,
          user_id: user.id.toString()
        })
      } else {
        window.Intercom('boot', {
          app_id: INTERCOM_APP_ID,
          ...userData,
          user_id: user.id.toString()
        })
        setLoaded(true)
      }
      window.intercomSettings = {
        action_color: theme.colors.navbarBackground,
        background_color: theme.colors.navbarBackground
      }
    }

    return () => {
      if (window.Intercom) {
        window.Intercom('shutdown')
        setLoaded(false)
        // @ts-expect-error
        delete window.Intercom
      }
    }
  }, [isOnTopicPage, data?.session, hide])
}
